import React from 'react';
import '../style.css'
import styles from '../index.module.css'
import CheckCircle from '../../../../assets/journaler/solutions/CheckCircle.png'
import JournalerWalletPage from '../../../../assets/journaler/solutions/wallet page demo.png'
import clsx from 'clsx';



const FeatureContentList = ({ content, index }) => (
  <div className={clsx(`row justify-content-between align-items-center`, styles.featureContentListItem)}>
    <div className='col-1'>
      <img src={CheckCircle} alt='tick' className={styles.checkCircleIcon} />
    </div>
    <div className='col-11 content-sub'>
      <p className={styles.featureContentText}>{content}</p>
    </div>
  </div>
)


const WalletConnection = (props) => {
  if (props.section === 1) {
    return (
      <div className='row justify-content-end pt-5 pb-5 colLeft'>
        <div className='col-lg-6 col-sm-12 pt-1 ' style={{ margin: 'auto 0' }}>
          <div>
            {props.content.header}
            {props.content.des && (
              <p className={`${styles.walletDescription} pb-4`}>
                {props.content.des}
              </p>
            )}
            <div className={props.content.des ? styles.contentListContainer : styles.contentListContainerWithMargin}>
              {props.content.content && props.content.content.map((content, index) => (
                <FeatureContentList key={index} content={content} index={index} />
              ))}
            </div>

          </div>
        </div>
        <div className='col-lg-6 col-sm-12'>
          <img className='img-fluid' src={props.image} alt="Responsive image" />
        </div>
      </div>
    )
  }
  else if (props.section === 2) {
    return (
      <div className='row justify-content-start pt-5 pb-5 colRight'>
        <div className='col-lg-6 col-sm-12' >
          <img className='img-fluid' src={props.image} alt="Responsive image" />
        </div>
        <div className='col-lg-6 col-sm-12' style={{ paddingLeft: '47px', margin: 'auto 0' }}>
          {props.content.header}
          {props.content.des && (
            <p className={`${styles.walletDescription} pb-4`}>
              {props.content.des}
            </p>
          )}
          <div className={props.content.des ? styles.contentListContainer : styles.contentListContainerWithMargin}>
            {props.content.content && props.content.content.map((content, index) => (
              <FeatureContentList key={index} content={content} index={index} />
            ))}
          </div>
        </div>
      </div>
    )
  }
  else {
    return (
      <div className='row justify-content-end pt-5 pb-5 colLeft'>
        <div className='col-lg-6 col-sm-12 pt-1 ' style={{ margin: 'auto 0' }}>
          <div>
            {props.content.header}
            {props.content.des && (
              <p className={`${styles.walletDescription} pb-4`}>
                {props.content.des}
              </p>
            )}
            <div className={props.content.des ? styles.contentListContainer : styles.contentListContainerWithMargin}>
              {props.content.content && props.content.content.map((content, index) => (
                <FeatureContentList key={index} content={content} index={index} />
              ))}
            </div>
          </div>
        </div>
        <div className='col-lg-6 col-sm-12'>
          <img className='img-fluid' src={props.image} alt="Responsive image" />
        </div>
      </div>
    )

  }


}

export default WalletConnection